export default {
  menu: {
    home: "Home",
    solution: "Solution",
    contact: "Contact",
    aboutus: "About Us"
    
  }
};



// WEBPACK FOOTER //
// ./src/lang/en/menu.js